module.exports = __webpack_public_path__ + "static/media/panel-image-sobregiro.c26eabb8.jpg";